var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"nav"},[_c('a',{staticClass:"nav-link nav-link-icon toggle-sidebar d-sm-inline d-md-none d-lg-none text-center",attrs:{"href":"#"},on:{"click":function($event){return _vm.handleClick()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }